<section
  class="home-v2__section home-v2__section--valor home-valor"
  aria-labelledby="home-valor-title"
>
  <div class="home-valor__inner">
    <div class="home-valor__bubble home-valor__bubble--top-lg" aria-hidden="true"></div>
    <div class="home-valor__bubble home-valor__bubble--top-sm" aria-hidden="true"></div>
    <div class="home-valor__bubble home-valor__bubble--bottom-sm" aria-hidden="true"></div>
    <div class="home-valor__bubble home-valor__bubble--bottom-lg" aria-hidden="true"></div>

    <div class="home-valor__layout">
      <div class="home-valor__content">
        <p class="home-valor__eyebrow">{{ content.eyebrow }}</p>

        <div class="home-valor__heading-block">
          <h2 id="home-valor-title" class="home-valor__title" [innerHTML]="titleSafe"></h2>
        </div>

        <div class="home-valor__copy" [innerHTML]="introSafe"></div>
      </div>

      <ul class="home-valor__benefits">
        @for (benefit of content.beneficios; track benefit.iconSrc) {
        <li class="home-valor__benefit-card">
          <span class="home-valor__benefit-bubble home-valor__benefit-bubble--a" aria-hidden="true"></span>
          <span class="home-valor__benefit-bubble home-valor__benefit-bubble--b" aria-hidden="true"></span>
          <span class="home-valor__benefit-bubble home-valor__benefit-bubble--c" aria-hidden="true"></span>
          <div class="home-valor__benefit-icon" aria-hidden="true">
            <img [src]="benefit.iconSrc" alt="" width="60" height="61" />
          </div>
          <div class="home-valor__benefit-content">
            <h3 class="home-valor__benefit-title">{{ benefit.title }}</h3>
            <p class="home-valor__benefit-text">{{ benefit.description }}</p>
          </div>
        </li>
        }
      </ul>
    </div>
  </div>
</section>
